import { Component } from "@angular/core"

@Component({
  standalone: false,
  selector: "app-impressum",
  templateUrl: "./impressum.component.html",
})
export class ImpressumComponent {}
